
export type GetAggregatedMetrics200Data = {[key: string]: {[key: string]: number}};
